import React from 'react'

const StrokeLogin = props => (
  <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="40.000000pt" height="40.000000pt" viewBox="0 0 40.000000 40.000000" preserveAspectRatio="xMidYMid meet" {...props}>
    <g transform="translate(0.000000,44.000000) scale(0.046667,-0.046667)" fill="#FFFFFF" stroke="none">
      <path d="M230 625 l0 -125 25 0 25 0 0 105 0 105 170 0 c94 0 170 -4 170 -9 0 -5 -23 -23 -50 -41 -82 -52 -80 -47 -80 -282 l0 -208 -105 0 -105 0 0 85 c0 84 0 85 -25 85 l-25 0 0 -105 0 -105 130 0 130 0 0 -53 c0 -83 10 -84 111 -15 l89 61 0 313 0 314 -230 0 -230 0 0 -125z"/>
      <path d="M340 486 l0 -26 -140 0 -140 0 0 -45 0 -45 140 0 140 0 0 -26 c0 -25 1 -24 58 23 41 33 55 51 48 58 -6 6 -32 28 -58 49 l-48 38 0 -26z"/>
    </g>
  </svg>
)

export default StrokeLogin;
